import { DocumenttypeDisplayModel, ContactDataDisplayModel, DocumentDisplayModel, GlobalEnumerationsAceRechtsform } from '@/api/model-index';
import { AnfrageNavigationFormComponent } from '@/core/components/anfrage-navigation-form/anfrage-navigation-form.component';
import { ComponentService } from '@/core/services/component.service';
import { PortalContextService } from '@/core/services/portal-context.service';
import { SectionService } from '@/core/services/section.service';
import { StateService } from '@/core/services/state.service';
import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
    selector: '',
    template: '',
    standalone: false
})
export abstract class BaseAenderungsantragNavigationFormComponent extends AnfrageNavigationFormComponent {
  public contactData: ContactDataDisplayModel;
  public attachments: DocumentDisplayModel[];
  public documentTypes: DocumenttypeDisplayModel[];

  public attachmentProcessStepForm: UntypedFormGroup = new UntypedFormGroup({
    attachments: new UntypedFormControl(null, []),
  });

  public get rechtsform(): GlobalEnumerationsAceRechtsform | null {
    return this.contactData?.institution?.rechtsform != null ? this.contactData.institution.rechtsform : null;
  }

  public get attachmentsFormControl(): UntypedFormControl {
    return <UntypedFormControl>this.attachmentProcessStepForm.controls["attachments"];
  }

  public get canSubmit(): boolean {
    return !this.formGroup.disabled 
  }

  public get isSubmitDisabled(): boolean {
    return this.portalContextService.CurrentAnfrage.portalzugriff?.hasFreigabeAenderungsantragAbsenden !== true;
  }

  constructor(
    protected sectionService: SectionService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected portalContextService: PortalContextService,
    protected stateService: StateService
  ) {
    super(sectionService, router, route, portalContextService);

    this.contactData = this.route.snapshot.data.contactData;
    this.documentTypes = this.portalContextService.CurrentAnfrage.documenttypes?.filter(x => x.aenderungsantragstypen?.includes(this.portalContextService.CurrentAenderungsantrag!.typ!)) ?? [] as DocumenttypeDisplayModel[];
    this.attachments = this.route.snapshot.data.attachments;

    this.router.events.subscribe((e) => {
      this.stateService.IsEndvalidationEnabled = false;
      this.formGroup.markAsUntouched();
      if (e instanceof NavigationEnd) {
        this.documentTypes = this.portalContextService.CurrentAnfrage.documenttypes?.filter(x => x.aenderungsantragstypen?.includes(this.portalContextService.CurrentAenderungsantrag!.typ!)) ?? [] as DocumenttypeDisplayModel[];
        this.attachments = this.route.snapshot.data.attachments;
        this.attachmentsFormControl.patchValue(this.attachments);
        this.initForm();
      }
    });

    this.attachmentsFormControl.patchValue(this.attachments);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.formGroup.statusChanges.subscribe((state) => this.updateAttachmentState());
    this.updateAttachmentState();
  }

  updateAttachmentState() {
    if (this.formGroup.disabled) {
      this.attachmentProcessStepForm.disable();
    }
    else if (this.formGroup.enabled) {
      this.attachmentProcessStepForm.enable();
    }
  }

  protected abstract initForm(): void;
}
